import { render, staticRenderFns } from "./MyQuotesRow.vue?vue&type=template&id=61da1c39&scoped=true&"
import script from "./MyQuotesRow.vue?vue&type=script&lang=js&"
export * from "./MyQuotesRow.vue?vue&type=script&lang=js&"
import style0 from "./MyQuotesRow.vue?vue&type=style&index=0&id=61da1c39&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61da1c39",
  null
  
)

export default component.exports